import { render, staticRenderFns } from "./descriptionForm.vue?vue&type=template&id=0dd20486&scoped=true&"
import script from "./descriptionForm.vue?vue&type=script&lang=js&"
export * from "./descriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./descriptionForm.vue?vue&type=style&index=0&id=0dd20486&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd20486",
  null
  
)

export default component.exports